import {Stores} from './index'
import {makeObservable, observable} from 'mobx'
import {Error} from 'rest/Error'

export class ErrorStore {
  stores: Stores

  errors: Error[]

  constructor(stores: Stores) {
    this.stores = stores
    this.errors = []
    makeObservable(this, {
      errors: observable,
    })
  }

  push = (e: Error) => this.errors.push(e)

  handle = (err: any) => {
    if (typeof err === 'string') err = {message: err}
    if (err.status === 400) {
      this.stores.NotificationStore.push(new Error(err as Error))
    } //this is for form control for if the  api returns field based errors
    else this.push(new Error(err as Error))
    // // console.error('ErrorStore', {err}, err.status)
    // if (err.status === 400) {
    //     throw err
    // } else //this is for form control for if the  api returns field based errors
    //     this.push(new Error(err as Error))
    return false
  }

  get list() {
    return this.errors.filter(i => !i.isDisplayed)
  }
}
